export const dimensions = [
  {
    id: 1,
    name: "Splits Dimension",
    description: "Assess your flexibility in various split positions",
    postures: [
      {
        id: "splits-middle",
        name: "Middle Split",
        description: "Forearms to the floor",
        instructions: "Sit in a wide-legged position and slowly lower your forearms to the floor between your legs. Hold this position while maintaining proper alignment.",
        duration: "Hold for 30 seconds",
        videoUrl: "/videos/splits-middle-demo.mp4"
      },
      {
        id: "splits-front",
        name: "Front Split",
        description: "Medium block on the floor",
        instructions: "From a lunge position, slowly slide your front leg forward and back leg backward until you reach your maximum split. Use a medium yoga block for support if needed.",
        duration: "Hold for 30 seconds each side",
        videoUrl: "/videos/splits-front-demo.mp4"
      },
      {
        id: "splits-standing",
        name: "Standing Split",
        description: "Upright spine with leg fully extended above 120 degrees",
        instructions: "Stand on one leg and lift the other leg as high as possible while keeping your spine upright. Aim for at least 120 degrees of hip flexion.",
        duration: "Hold for 15 seconds each side",
        videoUrl: "/videos/splits-standing-demo.mp4"
      },
      {
        id: "splits-lotus",
        name: "Half Lotus",
        description: "1/2 lotus position",
        instructions: "Sit cross-legged and place one foot on top of the opposite thigh. Keep your spine straight and shoulders relaxed.",
        duration: "Hold for 30 seconds each side",
        videoUrl: "/videos/splits-lotus-demo.mp4"
      }
    ]
  },
  {
    id: 2,
    name: "Forward Fold Dimension",
    description: "Test your forward folding flexibility",
    postures: [
      {
        id: "forward-fold-wide",
        name: "Wide Leg Forward Fold",
        description: "Hands on the floor between the feet",
        instructions: "Stand with feet wide apart, fold forward from the hips and place your hands on the floor between your feet. Keep your legs straight and spine long.",
        duration: "Hold for 45 seconds",
        videoUrl: "/videos/forward-fold-wide-demo.mp4"
      }
    ]
  },
  {
    id: 3,
    name: "Twisting Dimension",
    description: "Evaluate your spinal rotation capacity",
    postures: [
      {
        id: "twisting-pasasana",
        name: "Pasasana",
        description: "Heels on floor, hips level with knees, no space between torso and thigh, hands in front",
        instructions: "Squat with heels on the floor, twist your torso to one side, bringing your hands together in front of your chest. Keep hips level with knees and eliminate space between torso and thigh.",
        duration: "Hold for 30 seconds each side",
        videoUrl: "/videos/twisting-pasasana-demo.mp4"
      }
    ]
  },
  {
    id: 4,
    name: "Backbend Dimension",
    description: "Assess your spinal extension and backbending capacity",
    postures: [
      {
        id: "backbend-bow",
        name: "Dhanurasana (Bow Pose)",
        description: "70 Kapalabati breaths with hands clasped to ankles x 3 sets",
        instructions: "Lie on your belly, bend your knees and grab your ankles. Lift your chest and thighs off the ground. Perform 70 Kapalabati breaths, repeat 3 times.",
        duration: "70 breaths x 3 sets",
        videoUrl: "/videos/backbend-bow-demo.mp4"
      },
      {
        id: "backbend-wheel",
        name: "Urdhva Dhanurasana (Wheel)",
        description: "70 Kapalabati breaths x 3 sets",
        instructions: "Lie on your back, place hands beside your head and feet near your glutes. Press up into wheel pose. Hold while performing 70 Kapalabati breaths, repeat 3 times.",
        duration: "70 breaths x 3 sets",
        videoUrl: "/videos/backbend-wheel-demo.mp4"
      },
      {
        id: "backbend-camel",
        name: "Ustrasana (Camel Pose)",
        description: "70 Kapalabati breaths with hands touching feet x 3 sets",
        instructions: "Kneel with shins on the ground, reach back to grab your heels. Open your chest and let your head drop back gently. Perform 70 Kapalabati breaths, repeat 3 times.",
        duration: "70 breaths x 3 sets",
        videoUrl: "/videos/backbend-camel-demo.mp4"
      },
      {
        id: "backbend-hero",
        name: "Supta Virasana (Reclined Hero)",
        description: "Lower the back onto the floor",
        instructions: "Sit in hero pose (kneeling with feet beside hips), then slowly lower your back to the floor. Keep knees together and breathe deeply.",
        duration: "Hold for 60 seconds",
        videoUrl: "/videos/backbend-hero-demo.mp4"
      }
    ]
  },
  {
    id: 5,
    name: "Handstand Dimension",
    description: "Test your handstand strength and balance",
    postures: [
      {
        id: "handstand-balance",
        name: "Wall Handstand Balance",
        description: "3rd stage handstand at wall with one foot off for 30 Kapalabati breaths",
        instructions: "Kick up into handstand against the wall, then lift one foot away from the wall. Hold this position while performing 30 Kapalabati breaths.",
        duration: "30 breaths",
        videoUrl: "/videos/handstand-balance-demo.mp4"
      },
      {
        id: "handstand-floating",
        name: "Floating Handstand",
        description: "Lift off floor without touching feet to floor x 10 Kapalabati breaths",
        instructions: "From a forward fold, place hands on the ground and lift both feet off the floor simultaneously. Hold for 10 Kapalabati breaths without touching feet down.",
        duration: "10 breaths",
        videoUrl: "/videos/handstand-floating-demo.mp4"
      },
      {
        id: "handstand-pushup",
        name: "Handstand Push-up",
        description: "10 reps with head touching medium yoga block",
        instructions: "In handstand position against the wall, lower your head to touch a medium yoga block, then press back up. Complete 10 repetitions.",
        duration: "10 repetitions",
        videoUrl: "/videos/handstand-pushup-demo.mp4"
      }
    ]
  },
  {
    id: 6,
    name: "Forearm Stand Dimension",
    description: "Evaluate your forearm stand progression",
    postures: [
      {
        id: "forearm-dolphin",
        name: "Dolphin",
        description: "Heels 1 inch off floor with straight legs",
        instructions: "Start in forearm plank, then lift your hips up and walk your feet closer to your elbows. Lift your heels 1 inch off the ground while keeping legs straight.",
        duration: "Hold for 30 seconds",
        videoUrl: "/videos/forearm-dolphin-demo.mp4"
      },
      {
        id: "forearm-kickup",
        name: "Dolphin Kick-ups",
        description: "Kick up all the way to wall with control up and down",
        instructions: "From dolphin pose, practice kicking up to the wall with control. Focus on controlled movement both up and down.",
        duration: "5 controlled kick-ups",
        videoUrl: "/videos/forearm-kickup-demo.mp4"
      }
    ]
  },
  {
    id: 7,
    name: "Shoulder Stand Dimension",
    description: "Assess your shoulder stand and bridge variations",
    postures: [
      {
        id: "shoulder-bridge",
        name: "Bridge",
        description: "Hips above shoulders but below knees with hands clasped behind back",
        instructions: "Lie on your back with knees bent, lift your hips up into bridge pose. Clasp your hands behind your back and ensure hips are above shoulders but below knee level.",
        duration: "Hold for 45 seconds",
        videoUrl: "/videos/shoulder-bridge-demo.mp4"
      }
    ]
  }
];

export const getDimensionById = (id) => {
  return dimensions.find(dimension => dimension.id === id);
};

export const getPostureById = (postureId) => {
  for (const dimension of dimensions) {
    const posture = dimension.postures.find(p => p.id === postureId);
    if (posture) return posture;
  }
  return null;
};
